export default __webpack_public_path__ + "static/media/constructionencoursActual.d70b0061.png";